module.exports = __webpack_public_path__ + "img/sub_title.58f02a2c.png";